export default class backgroundImage {
    constructor() {
        this._init();
    }

    _init () {
        if (!$('.bg-image-js').length || $('.ccm-edit-mode').length) {
            return;
        }

        $('.bg-image-js').each(function () {
            let $img = $(this).find('img');
            $img.css({
                'z-index': '-1',
                'position': 'relative'
            });

            let imgSrc = $img.attr('src').split('/');

            imgSrc = imgSrc.map( str => {
                if (str === 'files') {
                    str = str + '/thumbnails/meet_the_team';
                }

                return str;
            });

            imgSrc = imgSrc.join('/');
            // files/thumbnails/meet_the_team/####/####/####/imageName.jpg

            $(this).addClass('bg-image').css({
                'background-image': 'url(' + imgSrc + ')'
            });
        });
    }
}
